import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import PreAssessmentQuestionChatbot from "./PreAssessmentQuestionChatbot/PreAssessmentQuestionChatbot";
import PreAssessmentQuestionDruidChatbot from "./PreAssessmentQuestionDruidChatbot/PreAssessmentQuestionDruidChatbot.jsx";
import PreAssessmentQuestionList from "./PreAssessmentQuestionList/PreAssessmentQuestionList";
import { useParams } from "react-router-dom";
import { fetchJob } from "../../store/job/action";
import { parseHtmlToText } from "./jobInterviewQnsUtil";
import { saveJobPreAssessment } from "../../store/job/action";
import AnvyImage from "@workspace/main/src/assets/images/Anvy 1.png";
import { notInitialized } from "react-redux/es/utils/useSyncExternalStore";

const PreAssessmentQuestion = (props) => {
  let { jobId } = useParams();
  const dispatch = useDispatch();
  const [jobDescription, setJobDescription] = useState("");
  const [preAssessmentData, setPreAssessmentData] = useState({
    questions: [],
    prompt: "",
  });
  const jobData = useSelector((state) => state.JobReducer.job);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [isDruidChatbot, setIsDruidChatbot] = useState(false);

  useEffect(() => {
    if (
      jobData &&
      (Object.keys(jobData).length === 0 || jobData?.jobId !== jobId)
    ) {
      dispatch(fetchJob(jobId));
    }
  }, [jobId]);

  useEffect(() => {
    if (jobData && Object.keys(jobData).length > 0) {
      setJobDescription(
        parseHtmlToText(jobData?.jobSubmissionData?.Jobdescription)
      );

      if (jobData?.preAssessmentData) {
        // Set the data
        setPreAssessmentData(jobData?.preAssessmentData);
      }

      if (jobData?.jobSubmissionData?.chatBot === "DruidAi") {
        setIsDruidChatbot(true);
      } else {
        setIsDruidChatbot(false);
      }
    }
  }, [jobData]);

  const handleSavePreAssessment = () => {
    // if (preAssessmentData?.questions.length > 0 && jobId) {
    if (jobId) {
      dispatch(
        saveJobPreAssessment({
          jobId: jobId,
          preAssessmentData,
        })
      );
    }
  };

  return (
    <div
      className="d-flex gap-3"
      style={{
        position: "relative",
        // height: "72.5vh",
        height: "95vh",
      }}
    >
      <div
        className="p-2"
        style={{
          minHeight: "100%",
          width: isChatbotOpen ? "72%" : "100%",
        }}
      >
        <PreAssessmentQuestionList
          jobDescription={jobDescription}
          preAssessmentData={preAssessmentData}
          setPreAssessmentData={setPreAssessmentData}
          handleSave={handleSavePreAssessment}
        />
      </div>
      <div>
        <div
          style={{
            position: "fixed",
            bottom: "62px",
            right: "20px",
            width: "25%",
            height: "63.5vh",
            zIndex: 9999, // Optional to ensure it's above other elements
            display: isChatbotOpen ? "block" : "none",
          }}
        >
          <PreAssessmentQuestionChatbot
            jobDescription={jobDescription}
            setPreAssessmentData={setPreAssessmentData}
          />
        </div>
        {isDruidChatbot && props.toRenderBot ? (
          <PreAssessmentQuestionDruidChatbot
            jobDescription={jobDescription}
            setPreAssessmentData={setPreAssessmentData}
          />
        ) :(
          <span
            style={{
              borderRadius: "50%",
              position: "fixed",
              bottom: "10px",
              right: "20px",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
              zIndex: 9999,
              overflow: "hidden",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
            onClick={() => {
              setIsChatbotOpen(!isChatbotOpen);
            }}
          >
            <span
              style={{
                borderRadius: "50%",
                bottom: "10px",
                right: "20px",
                width: "42.5px",
                height: "42.5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#D1D2D2",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                zIndex: 9999,
                overflow: "hidden",
              }}
            >
              <img
                src={AnvyImage}
                alt="Any bot image"
                style={{
                  width: "85%",
                  height: "85%",
                  objectFit: "contain",
                }}
              />
            </span>
          </span>
        )}
      </div>
    </div>
  );
};

export default PreAssessmentQuestion;
